
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined';
import CalendarViewWeekOutlinedIcon from '@mui/icons-material/CalendarViewWeekOutlined';
import InputIcon from '@mui/icons-material/Input';
import { CallReceivedOutlined, Contacts, IntegrationInstructionsOutlined, LibraryAddCheckOutlined } from '@mui/icons-material';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import { ReactComponent as ReturnPackage } from "../../../../../../styles/svg/package-return.svg";
export const getSettingsWarehouseGeneralCoreConfig = (isFulfilment) => {
    // Return different config objects based on isFulfilment
    return {
        pickBasis:  {
            title: 'pick_basis',
            icon: <AccountTreeOutlinedIcon />,
        },
        inbound:  {
            title: 'inbound',
            icon: <CallReceivedOutlined />,
        },
        echeck:  {
            title: 'echeck',
            icon: <LibraryAddCheckOutlined />,
        },
        orders:  {
            title: 'orders',
            icon: <ShoppingCartOutlinedIcon />,
        },
        // Unccoment when app version 2.0.4 is out
        return:  {
            title: 'return',
            icon: <ReturnPackage />,
        },
        ...(isFulfilment ? {
            invoicing: {
                title: 'invoicing',
                icon: <ReceiptLongIcon />,
            }
        } : {}),
        ...(isFulfilment ? {
            relation:  {
                title: 'relation',
                icon: <Contacts />,
            },
        } : {}),
        ...(isFulfilment ? {
            returnPortal:  {
                title: 'return_portal',
                icon: <AssignmentReturnIcon />,
            },
        } : {}),
        // ...(isFulfilment ? {
        //     serviceDesk:  {
        //         title: 'service_desk',
        //         icon: <SupportAgentIcon />,
        //     },
        // } : {}),
        scorecard:  {
            title: 'scorecard',
            icon: <LeaderboardOutlinedIcon />,
        },
        integrations:  {
            title: 'integrations',
            icon: <IntegrationInstructionsOutlined />,
        },
        //Only the case because we only have 1 general setting right now and it is dependent on isFulfilment
        general:  {
            title: 'general',
            icon: <SettingsOutlinedIcon />,
        },
    };
};